import { z } from 'zod';

export const contactSchema = z.object({
  name: z.string().trim().min(1, 'Name is required').max(100, 'Name too long'),
  email: z.string().trim().email('Invalid email').max(254, 'Email too long'),
  apartment: z.string().max(50).optional().or(z.literal('')),
  dates: z.string().max(100).optional().or(z.literal('')),
  message: z.string().trim().min(10, 'Message must be at least 10 characters').max(5000, 'Message too long'),
});

export type ContactFormData = z.infer<typeof contactSchema>;
